import React, { ReactNode } from "react";
import { style } from "typestyle";

type LabeledActionProps = {
  label?: string;
  id: string;
  children?: ReactNode;
};

export default function LabeledAction(props: LabeledActionProps) {
  if (!props.label) {
    return <div id={`workflow-action-${props.id}`}>{props.children}</div>;
  }

  return (
    <div className="labeledAction" id={`workflow-action-${props.id}`}>
      <div
        className={style({
          fontWeight: 500,
          color: "rgba(0,0,0,0.87)",
          fontSize: "20px",
          paddingBottom: "8px",
          lineHeight: "28px",
        })}
      >
        {props.label}
      </div>
      <div className="labeledAction-action">{props.children}</div>
    </div>
  );
}
